import * as metronome from 'worker-timers'; 

export class Metronome {
  constructor(bpm, measure) {
    this.tick = ((1000 * 60) / bpm);
    this.pause = true;
    this.id = undefined;
    this.metronome = document.getElementById('metro-audio');
    this.muted = true
    //this.metronome.muted = this.muted;
    console.log("Metronome received params",bpm,measure)
    this.measure = measure !== 0 ? (measure/4 * 1000) : 0;
    console.log("Start Tick at" ,bpm,this.tick)
    console.log("Measures", this.measure, measure);
    this.started = false;
  }

  start() {
    console.log("Starting metronome at",this.measure)
    const self = this;
    if (this.id === undefined) {
      return;
      setTimeout(() => {
        self.pause = false;
        self.id = metronome.setInterval(()=>{
          if (self.pause) return;
          this.metronome.pause();
          this.metronome.currentTime = 0.0;
          this.metronome.play();
        },this.tick);
      },this.measure);
    } else {
      this.pause = false;
    }
  }


  toggleMute = (mute) => {
    return;
    this.muted = mute;
    this.metronome.muted = !this.muted;
  }

  pauseTick() {
    this.pause = !this.pause;
  }

  isRunning(){
    return !this.pause;
  }

  tearDown() {
    this.pause = true;
    clearInterval(this.id);
    this.id = undefined;
  }
}
